import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAttendanceRegularizationEntry } from './hooks/useAttendanceRegularizationEntry';
import AttendanceRegularizationForm from './components/AttendanceRegularizationForm';

export default function AttendanceRegularizationEntryScreen() {
  const navigate = useNavigate();
  const { state, actions } = useAttendanceRegularizationEntry();

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-outline-variant/15 pb-4">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('/attendance/attendance-regularization')}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-outline-variant/30 bg-surface-container-lowest text-on-surface hover:bg-surface-container-high transition cursor-pointer shadow-xs"
            title="Back to Regularization List"
          >
            <span className="material-symbols-outlined text-lg">arrow_back</span>
          </button>
          <div>
            <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-on-surface">
              {state.isView
                ? 'View Attendance Regularization'
                : state.isEdit
                ? 'Edit Attendance Regularization'
                : 'Attendance Regularization'}
            </h1>
            <p className="mt-0.5 text-xs text-on-surface-variant font-medium">
              {state.isView
                ? 'Read-only view of employee attendance regularization details'
                : 'Submit mis-punch records and out-of-office attendance regularization'}
            </p>
          </div>
        </div>
      </section>

      {/* Entry Form */}
      <AttendanceRegularizationForm state={state} actions={actions} />
    </div>
  );
}
